import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import { DLRichTextEditor, PrimaryButton } from 'appSrc/components/UI';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import ProductInsertModal from 'appSrc/components/Modals/ProductInsert';
import style from './styles/style.module.css';


class EditArticleTextModal extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            articleText: props.article.primary_text,
            fetching: false,
            showProductInsertModal: false,
        };
    }
    updateArticleText = ( value ) => {
        this.setState( { articleText: value } );
    }
    openInsertModal = () => {
        this.setState( { showProductInsertModal: true } );
    }
    closeInsertModal = () => {
        this.setState( { showProductInsertModal: false } );
    }
    insertProduct = ( delta ) => {
        let quill = this._dlrte._rte.editor;
        let range = quill.getSelection( true );

        quill.insertText( range.index, '\n', 'user' );
        quill.insertEmbed( range.index + 1, delta.className, { ...delta }, 'user' );
        quill.setSelection( range.index + 2, 'silent' );

        this.setState( { showProductInsertModal: false } );
    }

    submitHandler = () => {
        this.setState( { fetching: true } );
        this.props.updateArticle( this.props.article.id, { primary_text: this.state.articleText } )
        .then( ( updatedArticle ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit( updatedArticle );
        } );
    }



    render() {
        const { articleText } = this.state;

        const modules = {
            toolbar: {
                container:[
                    [{ header: [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline', 'link', 'align'],
                    [ 'nbsp', { 'color': [] }],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    ['product', 'image'],
                ],
                handlers: {
                    'product': this.openInsertModal,
                },
            },
            'nbsp-module': true,
            clipboard: {
                matchVisual: false,
            },
        };

        return (
            <DLModal title='Edit Article Text'
            className={ style.editTextModal }
            closeHandler={ this.props.closeModal }>
                <div>
                    <DLRichTextEditor value={ articleText }
                    childRef={ ( el ) => { this._dlrte = el; } }
                    modules={ modules }
                    onChange={ this.updateArticleText } />

                    <PrimaryButton label='Submit'
                    onClick={ this.submitHandler } />
                </div>
                { this.state.showProductInsertModal &&
                    <ProductInsertModal products={ this.props.article.desires }
                    onSubmit={ this.insertProduct }
                    closeModal={ this.closeInsertModal }/>
                }
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
EditArticleTextModal.defaultProps = {
    onSubmit: () => {},
};

const mapDispatchToProps = () => {
    return {
        updateArticle: ( id, data ) => {
            return dAPI.patch( `/admin/content/${ id }`, dAPI.clean.admin.article( data ) );

        },
    };
};

export default connect( null, mapDispatchToProps )( EditArticleTextModal );
